"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

require("core-js/modules/es6.function.name");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _lang = _interopRequireDefault(require("@/lang"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
var _default = {
  name: "payChannelCost:view",
  // props: ['payChannelId'],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      payChannelId: '',
      controllerPath: "payChannelCost",
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: false,
      addDialogVisible: false,
      netwayCodeEnums: [],
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        netwayCode: "",
        currency: "",
        isDefaultCurrency: ""
      },
      addInformationParameter: {
        id: "",
        currency: "",
        // costValue: "",
        // minAmount: "",
        netwayCode: "",
        isDefaultCurrency: 0,
        description: "",
        remark: "",
        createTime: "",
        creator: ""
      },
      multipleSelection: [],
      rules: {
        currency: [{
          required: true,
          message: _lang.default.t('channel.currencyText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }],
        isDefaultCurrency: [{
          required: true,
          message: _lang.default.t('channel.currencyText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }],
        netwayCode: [{
          required: true,
          message: _lang.default.t('channel.netwayCodeText') + " " + _lang.default.t('warningMessage.cannotBeEmpty'),
          trigger: 'blur'
        }] // minAmount: [{
        //   required: true,
        //   message:
        //     i18n.t('channel.minAmountText') + " "
        //     + i18n.t('warningMessage.cannotBeEmpty'),
        //   trigger: 'blur'
        // }],
        // costValue: [{
        //   required: true,
        //   message:
        //     i18n.t('channel.costText') + " "
        //     + i18n.t('warningMessage.cannotBeEmpty'),
        //   trigger: 'blur'
        // }],

      }
    };
  },
  watch: {
    // Watch cache items to refresh the page E.g. call initData
    payChannelId: function payChannelId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initData();
      }
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getCacheItems();

            case 2:
              this.initData();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  activated: function () {
    var _activated = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getCacheItems();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function activated() {
      return _activated.apply(this, arguments);
    }

    return activated;
  }(),
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['netwayCodeOption', 'currencyTypeOption', 'booleanStateOption'])),
  methods: {
    initData: function initData() {
      var _this2 = this;

      this.handleNetwayCode(); //If channel id is undefined, return to previous page

      if (this.payChannelId === undefined) {
        //Go back to previous webpage and remove tag
        this.$store.dispatch('tagsView/delView', this.$route).then(function () {
          _this2.$router.go(-1);
        });
      } else {
        this.getList();
      }
    },
    // Map all the cache items to local state
    getCacheItems: function () {
      var _getCacheItems = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var payChannelId;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$store.dispatch('cacheManager/getCacheItem', {
                  page: this.$options.name,
                  itemKey: 'payChannelCost'
                });

              case 2:
                payChannelId = _context3.sent;
                this.payChannelId = payChannelId; // if(organizationCode){
                //   this.organizationCode = organizationCode;
                // }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCacheItems() {
        return _getCacheItems.apply(this, arguments);
      }

      return getCacheItems;
    }(),
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    // testData() {
    //   let item = {};
    //   item.id = 1;
    //   item.payChannelName = "Test";
    //   item.moneyType = "HKD";
    //   item.netwayCode = "ZFB"
    //   item.costValue = "1.1";
    //   item.createTime = "2021-07-06 00:00:00";
    //   item.creator = "Peter Chan";
    //
    //   this.list.push(item);
    // },
    getList: function getList() {
      var _this3 = this;

      //If channel id is undefined, return to previous page
      if (this.payChannelId === undefined) {
        //Go back to previous webpage and remove tag
        this.$store.dispatch('tagsView/delView', this.$route).then(function () {
          _this3.$router.go(-1);
        });
      } //Get search parameters


      var params = this.getQueryParams(); // this.testData();

      this.listLoading = false;

      _httpUtils.default.post(this.controllerPath, "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
      }).catch(function (error) {
        if (error.status === 404) {
          _this3.$message({
            message: error.error,
            type: 'error'
          });
        } else {
          _this3.$message({
            message: error.message,
            type: 'error'
          });
        }
      }).finally(function (_) {
        _this3.listLoading = false;
      });

      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        currency: this.queryParameter.currency,
        netwayCode: this.queryParameter.netwayCode,
        channelId: this.payChannelId,
        isDefaultCurrency: this.queryParameter.isDefaultCurrency
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        channelId: this.payChannelId,
        currency: this.addInformationParameter.currency,
        // costValue: this.addInformationParameter.costValue,
        // minAmount: this.addInformationParameter.minAmount,
        netwayCode: this.addInformationParameter.netwayCode,
        isDefaultCurrency: this.addInformationParameter.isDefaultCurrency,
        // description: this.addInformationParameter.description,
        // remark: this.addInformationParameter.remark,
        createTime: this.addInformationParameter.createTime,
        createUsername: this.addInformationParameter.creator
      };
    },
    //Handle add channel cost
    handleAdd: function handleAdd() {
      var _this4 = this;

      var _this = this;

      this.$refs['addInformation'].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          var action;

          if (_this.updateChannelFlag) {
            action = "update";
          } else {
            action = "add";
          }

          if (_this4.controllerPath && action) {
            _this4.listLoading = true;

            _httpUtils.default.post(_this4.controllerPath, action, null, params).then(function (res) {
              if (action === "add") {
                if (res.code === 200) {
                  _this4.$message({
                    message: _lang.default.t('warningMessage.addChannelCostSuccessMessage'),
                    type: 'success'
                  });
                }

                if (res.code === 500) {
                  _this4.$message({
                    message: _lang.default.t('warningMessage.channelCostExistMessage'),
                    type: 'warning'
                  });
                }
              }

              if (action === "update") {
                if (res.code === 200) {
                  _this4.$message({
                    message: _lang.default.t('warningMessage.updateChannelCostSuccessMessage'),
                    type: 'success'
                  });
                }

                if (res.code === 500) {
                  _this4.$message({
                    message: _lang.default.t('warningMessage.channelCostExistMessage'),
                    type: 'warning'
                  });
                }
              }

              _this4.handleResetAdd();

              _this4.handleFilter();
            }).catch(function (error) {
              _this4.$message({
                message: error.message,
                type: 'error'
              });
            });

            setTimeout(function () {
              _this4.listLoading = false;
            }, 1 * 1000);
          }
        } else {
          return false;
        }
      });
    },
    deleteChannelCost: function deleteChannelCost(channelCostIds) {
      var _this5 = this;

      _httpUtils.default.post(this.controllerPath, "batchDelete", null, channelCostIds).then(function (res) {
        _this5.$message({
          message: _lang.default.t('warningMessage.deleteRecordSuccessMessage'),
          type: 'success'
        });

        _this5.handleFilter();
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        var channelCostIds = [];
        channelCostIds.push(id);

        _this6.$nextTick(function (_) {
          _this6.deleteChannelCost(channelCostIds);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this7 = this;

      var _this = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectRecordToDeleteMessage'),
          type: 'error'
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.deleteChannelCostConfirmMessage'), _lang.default.t('warningMessage.deleteChannelCostMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var channelCostIds = [];

          for (var item in _this.multipleSelection) {
            channelCostIds.push(_this.multipleSelection[item].id);
          }

          _this7.$nextTick(function (_) {
            _this7.deleteChannelCost(channelCostIds);
          });
        }).catch(function (_) {});
      }
    },
    //Fill in parameters for updating pay channel cost
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.currency = row.currency;
      this.addInformationParameter.netwayCode = row.netwayCode;
      this.addInformationParameter.createTime = row.createTime;
      this.addInformationParameter.isDefaultCurrency = row.isDefaultCurrency;
      this.addInformationParameter.creator = row.createUsername; // this.getChannelOperatorList();

      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    //Reset input parameters
    handleReset: function handleReset() {
      this.addInformationParameter.id = "";
      this.addInformationParameter.currency = "";
      this.addInformationParameter.netwayCode = "";
      this.addInformationParameter.costValue = "";
      this.addInformationParameter.minAmount = "";
      this.addInformationParameter.description = '';
      this.addInformationParameter.remark = '';
      this.addInformationParameter.creator = '';
      this.addInformationParameter.createTime = '';
      this.addInformationParameter.isDefaultCurrency = 0;
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this8 = this;

      this.handleReset();
      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.$nextTick(function (_) {
        _this8.$refs['addInformation'].clearValidate();
      });
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //Convert currency
    convertCurrencyCodeToName: function convertCurrencyCodeToName(val) {
      if (!this.currencyTypeOption || !this.currencyTypeOption.length) return;
      var currency = this.currencyTypeOption.find(function (currency) {
        return currency.key === val;
      });

      if (currency) {
        return currency.display_name;
      } else {
        return "";
      }
    },
    //Convert netway
    convertNetWayCodeToName: function convertNetWayCodeToName(val) {
      if (!this.netwayCodeEnums || !this.netwayCodeEnums.length) return;
      var netway = this.netwayCodeEnums.find(function (netway) {
        return netway.key === val;
      });

      if (netway) {
        return netway.display_name;
      } else {
        return "";
      }
    },
    convertBooleanStateToName: function convertBooleanStateToName(name) {
      if (!(this.booleanStateOption && this.booleanStateOption.length)) {
        return;
      }

      var found = this.booleanStateOption.find(function (item) {
        return item.key === name;
      });

      if (found) {
        return found.display_name;
      } else {
        return "";
      }
    }
  }
};
exports.default = _default;